import BrandOrdersActionRequiredPage from "@faire/prototype-playground/workspace/sp/brand-orders-action-required";
import FaireSourceDownfunnelPage from "@faire/prototype-playground/workspace/sp/faire-source-downfunnel";
import NewToFaireSourceFilterPage from "@faire/prototype-playground/workspace/sp/new-to-faire-source-filter";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const FbFToFbBOrderFlipDropdownPage = lazy(
  () => import("../../pages/FbFToFbBOrderFlipDropdown")
);
const FbFToFbBOrderFlipSelectorPage = lazy(
  () => import("../../pages/FbFToFbBOrderFlipSelector")
);

export function SagarPatelRoutes() {
  return (
    <Switch>
      <Route
        path="/sp/brand-orders-action-required"
        component={BrandOrdersActionRequiredPage}
      />
      <Route
        path="/sp/faire-source-downfunnel"
        component={FaireSourceDownfunnelPage}
      />
      <Route
        path="/sp/fbf-fbb-order-flip-dropdown"
        component={FbFToFbBOrderFlipDropdownPage}
      />
      <Route
        path="/sp/fbf-fbb-order-flip-selector"
        component={FbFToFbBOrderFlipSelectorPage}
      />
      <Route
        path="/sp/new-to-faire-source-filter"
        component={NewToFaireSourceFilterPage}
      />
    </Switch>
  );
}

export const slug = "sp";
